import { getStorage, setStorage } from '@/storage';
import { timeInSeconds } from '@/utils';
import createListenerStore from './createListenerStore';

export default function createGlobalListenerStore({ onLocationChange = () => {}, onSessionChange = () => {} } = {}) {
	const state = {
		currentLocation: document.location.href,
		previousLocation: getStorage('previousLocation', 'sessionStorage') ?? document.referrer,
		session: typeof getStorage('session') === 'number' ? getStorage('session') : timeInSeconds(),
	};

	const store = createListenerStore();

	function setListeners() {
		store.setIntervalListener(() => {
			const didChange = state.currentLocation !== document.location.href;
			if (didChange) {
				state.previousLocation = state.currentLocation;
				state.currentLocation = document.location.href;
				setStorage('previousLocation', state.previousLocation, 'sessionStorage');
				onLocationChange();
			}
		}, 1000);

		store.setIntervalListener(() => {
			state.session = timeInSeconds();
			setStorage('session', state.session);
			onSessionChange();
		}, 30000);
	}

	return {
		setListeners,
		clearListeners: () => store.clearListeners(true),
		getCurrentLocation: () => state.currentLocation,
		getPreviousLocation: () => state.previousLocation,
		getSession: () => state.session,
	};
}
